export const state = () => ({
  user: {
    name: 'Ahmed',
    email: 'ahmed@gmail.com'
  }
})

export const mutations = {}
export const actions = {}
